import React from 'react';
import { ChevronRight } from 'lucide-react';

import { getMenuCategoryIcon } from '@/lib/menuCategoryIcons';
import { cn } from '@/lib/utils';

/**
 * Portada de categorías (layout `categories`): el cliente elige sección antes de ver platos.
 */
export default function CatalogCategoryLanding({
  categories = [],
  onSelectCategory,
  accent,
  branding: b,
  business,
  standard,
  premium,
  businessName,
}) {
  const iconOptions = business ? { business } : undefined;

  return (
    <div className="py-2" data-testid="catalog-category-landing">
      <div className="mb-8 text-center">
        {business?.logo_url ? (
          <img
            src={business.logo_url}
            alt=""
            className="mx-auto mb-3 h-16 w-16 rounded-full object-cover border"
            style={premium ? { borderColor: b.card_border_color } : undefined}
          />
        ) : (
          <div
            className="mx-auto mb-3 flex h-16 w-16 items-center justify-center rounded-full text-lg font-bold"
            style={{
              backgroundColor: accent,
              color: premium ? b.button_text_color : '#fff',
            }}
          >
            {(businessName || 'M').slice(0, 1).toUpperCase()}
          </div>
        )}
        <h2
          className={cn('text-xl font-bold tracking-tight', standard && 'text-foreground')}
          style={premium ? { color: b.text_color } : undefined}
        >
          {businessName || 'Menú'}
        </h2>
        <p
          className={cn('mt-1 text-sm', standard && 'text-muted-foreground')}
          style={premium ? { color: b.muted_text_color } : undefined}
        >
          Elegí una categoría
        </p>
      </div>

      <div className="space-y-3 max-w-md mx-auto">
        {categories.map((cat) => {
          const Icon = getMenuCategoryIcon(cat.name, iconOptions);
          return (
            <button
              key={cat.id}
              type="button"
              data-testid={`catalog-category-landing-${cat.id}`}
              onClick={() => onSelectCategory(cat.id)}
              className={cn(
                'flex w-full items-center gap-3 rounded-xl px-4 py-3.5 text-left transition-transform active:scale-[0.99]',
                standard && 'shadow-sm',
              )}
              style={{
                backgroundColor: accent,
                color: premium ? b.button_text_color : '#FFFFFF',
              }}
            >
              <span
                className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full"
                style={{
                  backgroundColor: premium ? b.background_color || b.card_background_color : '#FFFFFF',
                }}
              >
                <Icon
                  className="h-5 w-5"
                  style={{ color: accent }}
                  aria-hidden
                />
              </span>
              <span className="flex-1 text-base font-extrabold tracking-wide uppercase">
                {cat.name}
              </span>
              <ChevronRight className="h-5 w-5 opacity-80" aria-hidden />
            </button>
          );
        })}
      </div>
    </div>
  );
}
